(function($) {  
    var state = {
        filter: [],
        addFilter: function(filter){
            this.filter.push("." + filter);
        },
        removeFilter: function(filter){
            this.filter.splice( this.filter.indexOf("."+filter), 1 );
        },
        render: function(){
            if (this.filter.length > 0){
                $(".feed-article").removeClass("resultset").filter(this.filter.join(",")).addClass("resultset");
            } else{
                $(".feed-article").addClass("resultset");
            }
            $(".feed-article").hide();
            $(".feed-article.resultset").slice(0,9).show();
        },
        toggleCheckbox: function(event) {
            let $e = $(event.target);
            if ($e.hasClass("theme-filter__item--active")) {
                $e.attr("aria-checked", "false").removeClass("theme-filter__item--active")
                this.removeFilter($e.data("value"));
            } else {
                $e.attr("aria-checked", "true").addClass("theme-filter__item--active")
                this.addFilter($e.data("value"));
            }
            this.render();
        }
    }

    /*
    $(".theme-filter__item").on("click", state.toggleCheckbox.bind(state));
    $(document).ready(function(){
        state.render();
    })
    */
})( jQuery );